<template>
  <div class="indexPage">
    <div class="banner">
      <img src="../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon4"><i class="iconfont icon-yonghu"></i></div>
      <div class="breadcrumb_item">业务资源管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">客户服务管理</div>
    </div>

    <div class="input_wrap flex-rowl">
      <div class="input_box search">
        <van-field
          v-model="params.keyword"
          ref="input"
          placeholder="输入关键字查找→"
          @focus="handleFocus"
          @blur="handleBlur"
          @keyup.enter="handleSearch"
        />
      </div>
      <div class="primary-button" @click="handleSearch">查找→</div>
    </div>

    <div class="screen_wrap">
      <div class="screen_list flex-rowl">
        <div class="screen_item" @click="handleSotr">默认</div>
        <div class="screen_item flex-between" @click="handleSotr(1)">
          <span>最近联系</span> <i class="iconfont icon-24gl-swapVertical"></i>
        </div>
        <div class="screen_item flex-between" @click="handleShowPopup(1)">
          <span>成交记录</span> <i class="iconfont icon-24gl-swapVertical"></i>
        </div>
        <div class="screen_item flex-between" @click="isShowPopup = true">
          <span>客户标签</span> <i class="iconfont icon-bottom"></i>
        </div>
      </div>
      <div class="screen_list screen_list_one flex-rowl" v-if="false">
        <div class="screen_item flex-between" @click="handleShowPopup(2)">
          <span>省/直辖市</span> <i class="iconfont icon-bottom"></i>
        </div>
        <div class="screen_item flex-between" @click="handleShowPopup(3)">
          <span>城市</span> <i class="iconfont icon-bottom"></i>
        </div>
        <div class="screen_item flex-between" @click="handleShowPopup(4)">
          <span>区域</span> <i class="iconfont icon-bottom"></i>
        </div>
      </div>
    </div>

    <div class="customer_wrap">
      <div class="customer_list" v-if="dataList.length > 0">
        <div
          class="customer_item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="handleDetail(item.id)"
        >
          <div class="item">
            <div class="txt flex-rowl">
              <p class="label">客户名称：</p>
              <p>
                {{ item.info_truename ? item.info_truename : item.ext_name }}
              </p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">企业名称：</p>
              <p>{{ item.other_companystr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">职务：</p>
              <p>{{ item.other_job }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">客户标签：</p>
              <p>{{ item.info_tag_idstr ? item.info_tag_idstr : "" }}</p>
              <!-- <div class="label_list flex-rowl">
                <div class="label_item">
                  {{ item.info_tag_idstr }}
                  <i class="iconfont icon-checkbox-checked-o"></i>
                </div>
              </div> -->
            </div>
          </div>
          <div class="item red">
            <div class="txt flex-rowl">
              <p class="label">补充分类：</p>
              <p>{{ item.other_typestr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">客户属性：</p>
              <p>{{ item.other_attrstr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">联系优先度：</p>
              <p>{{ item.other_yxdstr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">成交记录：</p>
              <p></p>
            </div>
          </div>
          <div class="item address">
            <div class="tit flex-rowl">
              <p class="label">所在地区：</p>
            </div>
            <div class="txt flex-rowl">
              <p>{{ item.other_provincename }}</p>
              <p>{{ item.other_cityname }}</p>
              <p>{{ item.other_areaname }}</p>
            </div>
            <div class="txt">
              <p>
                {{ item.other_address }}
              </p>
            </div>
          </div>
          <div class="item red">
            <div class="txt flex-rowl">
              <p class="label">当前客户归属：</p>
              <p>{{ item.info_remark }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">最新触达日期：</p>
              <p>{{ item.createdate | formatDate }}</p>
            </div>
          </div>
          <div class="item">
            <div class="txt flex-rowl">
              <p class="label">最近联系情况：</p>
              <p>{{ item.getstatestr }}</p>
            </div>
            <div class="txt flex-rowl">
              <p class="label">联系结果：</p>
              <p>{{ item.resultdstr }}</p>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <div class="item" @click="handleReturn">返回</div>
    </div>

    <!-- 弹窗 -->
    <van-popup
      class="custom_popup"
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div v-if="popupType == 1">
        <van-picker
          show-toolbar
          :columns="customerOptin"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="customerOptin.length > 0"
        />
        <van-empty
          v-else-if="customerOptin.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="popupType == 2">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="popupType == 3">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="popupType == 4">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getCustomerList,
  getCustomerLabel,
  getProvince,
  getCity,
  getArea,
  encryptstringadd,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "serviceIndex",
  data() {
    return {
      isShowTabbar: true,
      type: 1,
      dataList: [],
      params: {
        pageindex: 1,
        pagesize: 10,
        orderlink: "", // 最近联系的排序 = 1 升序 2 降序
        orderamount: "", // 成交金额的排序 = 1 升序 2 降序（该字段暂不生效）
        info_tag_id: "", //
        keyword: "",
        info_userid: "",
      },
      listTotal: 0,
      loading: false, // 是否正在加载中

      // 客户标签
      customerOptin: [], // 弹窗
      customerTxt: "",

      isShowPopup: false,
      popupType: 1,
      provinceList: [],
      provinceTxt: "",
      cityList: [],
      cityTxt: "",
      areaList: [],
      areaTxt: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    this.params.info_userid = this.$store.state.USERINFO.openid;
    this.getCustomerLabel();
    this.getCustomerList();
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    handleSearch() {
      this.params.pageindex = 1;
      this.dataList = [];
      this.getCustomerList();
    },

    // 获取数据
    getCustomerList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getCustomerList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },

    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getCustomerList();
      }
    },

    // 排序
    handleSotr(type) {
      this.pageindex = 1;
      this.dataList = [];
      if (type == 1) {
        this.params.orderlink = this.params.orderlink == 1 ? 2 : 1;
      } else if (type == 2) {
        this.params.orderamount = this.params.orderamount == 1 ? 2 : 1;
      } else {
        this.params.orderlink = 1;
        this.params.orderamount = 1;
      }
      this.getCustomerList();
    },

    handleReturn() {
      history.back();
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },

    // 显示弹窗
    handleShowPopup(type) {
      this.popupType = type;
      if (type == 2) {
        this.getProvince(true);
      } else if (type == 3) {
        this.getCity(true);
      } else if (type == 4) {
        this.getArea(true);
      }
      this.isShowPopup = true;
    },

    onConfirm(e) {
      let { popupType } = this;
      if (popupType == 1) {
        this.customerTxt = e.text;
        this.params.info_tag_id = e.id;
      } else if (popupType == 2) {
        this.provinceTxt = e.text;
        this.initData.province = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.cityTxt = "";
        this.initData.city = "";
        this.initData.addr = "";
      } else if (popupType == 3) {
        this.cityTxt = e.text;
        this.initData.city = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.initData.addr = "";
      } else if (popupType == 4) {
        this.areaTxt = e.text;
        this.initData.area = e.id;
        this.initData.addr = "";
      }
      this.loading = true;
      this.isShowPopup = false;

      this.pageindex = 1;
      this.dataList = [];
      this.getCustomerList();
    },
    // 获取客户标签
    getCustomerLabel() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getCustomerLabel(params).then((res) => {
        let newCustomerOptin = [
          {
            text: "全部",
            id: "",
          },
        ];
        res.list.forEach((v) => {
          newCustomerOptin.push({
            text: v.labelname,
            id: v.id,
          });
        });
        this.customerOptin = newCustomerOptin;
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        let newProvince = [];
        res.forEach((v) => {
          newProvince.push({
            text: v.areaname,
            id: v.areaid,
          });
        });
        this.provinceList = newProvince;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.initData.province).then((res) => {
        let newcity = [];
        res.forEach((v) => {
          newcity.push({
            text: v.cityname,
            id: v.cityid,
          });
        });
        this.cityList = newcity;
        this.loading = false;
        if (isClick && newcity.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.initData.city).then((res) => {
        let newarea = [];
        res.forEach((v) => {
          newarea.push({
            text: v.addrname,
            id: v.addrid,
          });
        });
        this.areaList = newarea;
        this.loading = false;
        if (isClick && newarea.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    handleDetail(id) {
      // this.$router.push(`/resourceIndex/rServiceDetail/${id}`);
      this.encryptstringadd("rServiceDetail", { id });
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  box-sizing: border-box;
  padding-bottom: 190px;
  .screen_wrap {
    padding: 50px;
    font-size: 20px;
    color: #464646;
    .screen_list {
      .screen_item {
        flex-shrink: 0;
        height: 40px;
        line-height: 40px;
        min-width: 90px;
        max-width: 160px;
        padding: 0 10px 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        margin-right: 10px;
        .iconfont {
          margin-left: 10px;
        }
      }
      &:last-child {
        margin-top: 20px;
      }
      &.screen_list_one {
        .screen_item {
          width: 210px;
          &:first-child {
            width: 190px;
            max-width: 190px;
          }
        }
      }
    }
  }
  .input_wrap {
    padding: 0 45px 10px;
    box-sizing: border-box;
    .primary-button {
      width: 145px;
      margin-left: 20px;
      font-size: 26px;
    }
  }
  .customer_wrap {
    font-size: 22px;
    color: #3c3c3c;
    width: 650px;
    margin: 0 auto 30px;
    .red {
      color: #ff0036;
    }
    .customer_list {
      .customer_item {
        margin-bottom: 30px;
        border: 1px solid #d2d2d2;
        padding: 40px;
        box-sizing: border-box;
      }
      .item {
        margin-bottom: 45px;
        .txt {
          margin-bottom: 15px;
          align-items: flex-start;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            white-space: nowrap;
            width: 160px;
            flex-shrink: 0;
          }
          .label_list {
            .label_item {
              border: 1px solid #d2d2d2;
              padding: 5px 10px 5px 20px;
              margin-right: 10px;
            }
          }
        }
        &.address {
          .tit {
            margin-bottom: 10px;
          }
          .txt {
            font-size: 20px;
            p {
              &:nth-child(2) {
                margin: 0 30px;
              }
            }
          }
        }
        p {
          line-height: 28px;
        }
      }
    }
  }

  .custom_popup {
    z-index: 1000002 !important;
  }
}
</style>